<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-content">
      <div class="modal-banner">
        <h3>{{ title }}</h3>
        <button class="close-button" @click="closeModal"><img src = "../assets/art/X_btn.png"></button>
      </div>
      <h2 class="modal-title">{{ title }}</h2>
      <div class="modal-body">
        <div v-if="photoName" class="video-wrapper" :style="`width:${photoWidth}%`">
          <img ref="image" :src="require(`@/assets/images/${photoName}`)" >
          <p v-if="credit" class="credit" ref="credit" ></p>
        </div>
        <p class="description" ref="description"></p>
      </div>
      <button class="place-block-button" @click="closeModal">Place Block</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalPopup',
  props: {
    visible: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      default: 'Modal Title',
    },
    photoName: {
      type: String,
      default: null,
    },
    photoWidth: {
      type: Number,
      default:50,
    },

    description: {
      type: String,
      default: 'This is a description for the modal popup.',
    },
    credit:{
      type:String,
      default:''
    }
  },
  emits: ['close'],
  mounted(){
    document.addEventListener("keydown",this.handleKeyDown)

  },
  unmounted(){
    document.removeEventListener("keydown",this.handleKeyDown)

  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    displayDescription(){
      let description=this.description?this.description:''
      description=description.replaceAll(('\n'), ('<br><br>'))
      this.$refs.description.innerHTML=description
    },
    displayCredit(){
      if(!this.credit){return}
      let credit=this.credit
      credit=credit.replaceAll(('\n'), ('<br>'))
      this.$refs.credit.innerHTML=credit
    },
    handleKeyDown(e){
      if(!this.visible){return}
      switch(e.key){
        case "x":
        case "Escape":
        case "Enter":
        case " ":
          this.closeModal()
      }
    }
  },
  watch:{
    visible(){
      if(this.visible){
        setTimeout(()=>{this.displayDescription();this.displayCredit()},100)

      }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  border-radius: 3px;
  width: 90%;
  max-width: 1000px;
  overflow: hidden;
  position: relative;
  padding: 0;
}

.modal-banner {
  background-image: url('../assets/art/popup_header01.png');
  height: 50px;
  position: relative;
  display:flex;
  justify-content:space-between;
  align-items:center;
}
.modal-banner h3{
    margin-left:3%;
    position:static;
    color:white;
    font-size:1.6rem;
}


.close-button {
  position: static;
  margin-right:20px;
  font-size: 24px;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
}

.close-button img{
  width:13px;
}

.modal-title {
  text-align: center;
  margin: 16px 0;

}

.modal-body {
    padding: 0 20px 20px;
    text-align: center;
    display:flex;
    flex-flow: row nowrap;
    gap: 1.5rem;
}

.video-wrapper {
    width:50%
}

.video-wrapper img {
  width: 100%;
  height: auto;
}

.description {
  margin:0 auto;
  margin-top: 10px;
  font-size: 1rem;
  width:80%;
  text-align: left;
  
}
.credit{
  margin-left:0rem;
  margin-top: 10px;
  margin-bottom:-50px;
  font-size: 1rem;

  text-align: center;

}

.place-block-button {
    display: block;
    margin: 0 auto 20px;
    background-color: #4a2a00;
    color: white;
    border: none;
    padding: 7px 60px;
    font-size: 1.1rem;
    cursor: pointer;
    border-radius: 16px;
    transition: background-color 0.3s ease;
    font-family: Verdaguera, serif;
}
</style>
